/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeExtendedRuntimeEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_EXTENDED_RUNTIME_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeExtendedRuntimeEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeExtendedRuntimeEnabledSettingParser.decode(input).map(res => new TierFreeExtendedRuntimeEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeExtendedRuntimeEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeExtendedRuntimeEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeExtendedRuntimeEnabledSettingParser.schema();
    }
}
